import React, { useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { Button } from "react-bootstrap";
import "./GetStartedPopup.css";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearReturnPath } from "../../StateManagement/Reducers/AccountSetupState";

const GetStartedPopup = ({
  title,
  description,
  currentStep,
  totalSteps,
  bullets = [],
  bullets2 = [],
  bullets3 = [],
  bullets4 = [],
  numberedBullets = [],
  bulletheading2,
  bulletheading,
  bullethead,
  onBack,
  onNext,
  onFinish,
  topClose,
  rightClose,
  onGotIt,
  width,
  onClose,
  thanksnote,
  arrowPosition, // 'left-top' | 'left-center' (default = none / use Semantic UI arrow)
  showBackdrop = false, // Add option to conditionally show backdrop
  backdropZIndex = 1000,
  nextButtonText,
  closeOnOutsideClick = false,
}) => {
  // Inject arrow-position override after all stylesheets (guaranteed last-write-wins)
  const ARROW_STYLE_ID = "centerarrow-top-override";
  if (typeof document !== "undefined" && !document.getElementById(ARROW_STYLE_ID)) {
    const el = document.createElement("style");
    el.id = ARROW_STYLE_ID;
    el.textContent =
      ".ui.popup.no-sui-arrow::before { display: none !important; }" +
      ".ui.popup.centerarrowpopup::before { top: 14px !important; margin-top: 0 !important; }";
    document.head.appendChild(el);
  }
  const history = useHistory();
  const popupRef = useRef(null);
  const returnPath = useSelector((state) => state?.returnPath?.path);
  const dispatch = useDispatch();

  useEffect(() => {
    const appBody = document.querySelector(".app-body");

    if (appBody) {
      appBody.style.setProperty("overflow", "unset", "important");
      appBody.style.setProperty("position", "unset", "important");
    }

    return () => {
      if (appBody) {
        appBody.style.removeProperty("overflow");
        appBody.style.removeProperty("position");
      }
    };
  }, []);

  useEffect(() => {
    if (!closeOnOutsideClick || !onClose) return;

    const handleClickOutside = (event) => {
      // If click is inside the popup, do nothing
      if (popupRef.current && popupRef.current.contains(event.target)) {
        return;
      }

      // Prevent the click from triggering underneath elements (like Tabs or Links)
      event.stopPropagation();
      event.preventDefault();

      onClose();
    };

    // Use capture phase (true) so we intercept the event before it reaches the target elements
    const timeoutId = setTimeout(() => {
      document.addEventListener("click", handleClickOutside, true);
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [closeOnOutsideClick, onClose]);

  const handleGotIt = () => {
    if (onGotIt) {
      onGotIt();
      return;
    }
    if (returnPath) {
      history.push(returnPath);
      dispatch(clearReturnPath());
      return;
    }
    history.push({
      pathname: `/schedule/calender`,
      state: { getstartedopen: true },
    });
  };

  return (
    <>
      {showBackdrop && typeof document !== "undefined" &&
        ReactDOM.createPortal(
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0, 0, 0, 0.4)",
              zIndex: backdropZIndex,
            }}
          />,
          document.body
        )}
      <div
        ref={popupRef}
        className={`get-started-popup ${topClose ? "top-close" : ""} ${rightClose ? "right-close" : ""}`}
        style={{ width: width, position: "relative" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Custom arrow — bypasses Popper.js which controls Semantic UI's ::before */}
        {arrowPosition === "left-top" && (
          <div
            style={{
              position: "absolute",
              left: "-24px",
              top: "6px",
              width: 0,
              height: 0,
              borderTop: "9px solid transparent",
              borderBottom: "9px solid transparent",
              borderRight: "9px solid #ffffff",
              filter: "drop-shadow(-2px 0px 1px rgba(34,36,38,0.18))",
              zIndex: 10,
            }}
          />
        )}
        {arrowPosition === "left-center" && (
          <div
            style={{
              position: "absolute",
              left: "-24px",
              top: "50%",
              transform: "translateY(-50%)",
              width: 0,
              height: 0,
              borderTop: "9px solid transparent",
              borderBottom: "9px solid transparent",
              borderRight: "9px solid #ffffff",
              filter: "drop-shadow(-2px 0px 1px rgba(34,36,38,0.18))",
              zIndex: 10,
            }}
          />
        )}
        {arrowPosition === "right-top" && (
          <div
            style={{
              position: "absolute",
              right: "-24px",
              top: "6px",
              width: 0,
              height: 0,
              borderTop: "9px solid transparent",
              borderBottom: "9px solid transparent",
              borderLeft: "9px solid #ffffff",
              filter: "drop-shadow(2px 0px 1px rgba(34,36,38,0.18))",
              zIndex: 10,
            }}
          />
        )}
        {arrowPosition === "right-center" && (
          <div
            style={{
              position: "absolute",
              right: "-24px",
              top: "50%",
              transform: "translateY(-50%)",
              width: 0,
              height: 0,
              borderTop: "9px solid transparent",
              borderBottom: "9px solid transparent",
              borderLeft: "9px solid #ffffff",
              filter: "drop-shadow(2px 0px 1px rgba(34,36,38,0.18))",
              zIndex: 10,
            }}
          />
        )}
        {arrowPosition === "top-right" && (
          <div
            style={{
              position: "absolute",
              right: "24px",
              top: "-20px",
              width: 0,
              height: 0,
              borderLeft: "9px solid transparent",
              borderRight: "9px solid transparent",
              borderBottom: "10px solid #ffffff",
              filter: "drop-shadow(0px -2px 1px rgba(34,36,38,0.18))",
              zIndex: 10,
            }}
          />
        )}
        <div className="popup-header">
          <h4 className="popup-title">{title}</h4>
          {onClose && (
            <span className="close-button" onClick={onClose}>
              ×
            </span>
          )}
        </div>

        <div className="popup-content">
          {typeof description === "string" ? (
            <p className="popup-description">{description}</p>
          ) : (
            <div className="popup-description">{description}</div>
          )}
          {bulletheading && (
            <p className="popup-bullet-heading">{bulletheading}</p>
          )}
          {bullethead && (
            <p className="popup-bullet-head">{bullethead}</p>
          )}
          {bullets.length > 0 && (
            <ul className="popup-bullets">
              {bullets.map((bullet, index) => (
                <li key={index} className="popup-bullet-item">
                  {bullet}
                </li>
              ))}
            </ul>
          )}

          {/* Numbered bullets */}
          {numberedBullets.length > 0 && (
            <ol className="popup-numbered-bullets">
              {numberedBullets.map((bullet, index) => (
                <li key={index} className="popup-number-item">
                  {bullet}
                </li>
              ))}
            </ol>
          )}

          {bullets4.length > 0 && (
            <ol className="popup-bullets">
              {bullets4.map((bullet, index) => (
                <li key={index} className="popup-bullet-item">
                  {bullet}
                </li>
              ))}
            </ol>
          )}

          {bulletheading2 && (
            <p className="popup-bullet-heading">{bulletheading2}</p>
          )}
          {bullets2.length > 0 && (
            <ul className="popup-bullets">
              {bullets2.map((bullet, index) => (
                <li key={index} className="popup-bullet-item">
                  {bullet}
                </li>
              ))}
            </ul>
          )}
          {bullets3.length > 0 && (
            <ol className="popup-orderbullets">
              {bullets3.map((bullet, index) => (
                <li key={index} className="popup-orderbullet-item">
                  {bullet}
                </li>
              ))}
            </ol>
          )}
          {thanksnote && <p>{thanksnote}</p>}
        </div>

        <div className="popup-footer">
          <div className="step-counter">
            {currentStep}/{totalSteps}
          </div>

          <div className="button-group">
            {onBack && (
              <Button
                className="popup-button back-button"
                variant="outline-primary"
                onClick={onBack}
              >
                Back
              </Button>
            )}
            {onNext ? (
              <Button
                className="popup-button next-button"
                variant="primary"
                onClick={onNext}
              >
                {nextButtonText || "Next"}
              </Button>
            ) : onFinish ? (
              <Button
                className="popup-button next-button"
                variant="primary"
                onClick={onFinish}
              >
                {nextButtonText || "Finish"}
              </Button>
            ) : (
              <Button
                className="popup-button next-button"
                variant="primary"
                onClick={handleGotIt}
              >
                Got It
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default GetStartedPopup;